import axios from '@/plugins/axios'

const BASE = 'consulta-pj'

export async function consultarPjPorCnpj(cnpj) {
  const { data } = await axios.post(
    `${BASE}/cnpj/${encodeURIComponent(cnpj)}`,
  )
  return data
}

export async function consultarPjPorEmail(body) {
  const { data } = await axios.post(`${BASE}/email`, body)
  return data
}

export async function consultarPjPorCep(body) {
  const { data } = await axios.post(`${BASE}/cep`, body)
  return data
}

export async function consultarPjPorTelefone(body) {
  const { data } = await axios.post(`${BASE}/telefone`, body)
  return data
}

export async function consultarPjPorRazaoSocial(body) {
  const { data } = await axios.post(`${BASE}/razao-social`, body)
  return data
}
